import { Container, Row, Col } from 'reactstrap';

const BotonArrepentimiento = () => {
    return (
        <Container className="mt-4 mb-5">
            <Row>
                <Col className="px-3">
                    <style>{`
                        .card-container {
                            background-color: #ffffff;
                            border-radius: 12px;
                            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                            padding: 30px 20px;
                            margin: 10px 0;
                        }
                        .email-link {
                            color: #007bff;
                            text-decoration: underline;
                            cursor: default;
                            word-break: break-all;
                            overflow-wrap: break-word;
                        }
                        .email-link:hover {
                            color: #0056b3;
                        }
                        @media (max-width: 480px) {
                            .email-link {
                                display: inline-block;
                                word-break: break-all;
                                max-width: 100%;
                            }
                        }
                        .content-text {
                            color: #34495E;
                            line-height: 1.8;
                            font-size: 18px;
                        }
                        .content-text strong {
                            color: #2c3e50;
                        }
                        .content-text ul {
                            padding-left: 20px;
                        }
                        .content-text li {
                            margin-bottom: 0px;
                        }
                    `}</style>
                    <div className="card-container">
                        <div className="content-text">
                            <p className="mb-3">
                                Si te comunicas por la <strong>SEGUNDA NOCHE</strong> de la <strong>FIESTA NACIONAL DE LA VENDIMIA</strong>, la misma lamentablemente se ha <strong>CANCELADO</strong>. El clima no dará tregua esta semana y no se ha podido ubicar un día para poder disfrutar de la fiesta en forma ordenada y segura.
                            </p>

                            <p className="mb-3"><strong>Con respecto a tus entradas, tienes dos opciones:</strong></p>

                            <p className="mb-3">
                                <strong>1..</strong> Canjearlas por entradas para asistir al recital que brindarán <strong>Abel Pintos, Angela Leiva y Maggie Cullen</strong> este <strong>Domingo 15 de Marzo a las 14hs</strong> en el mismo <strong>Teatro Griego Frank Romero Day</strong>.
                                Creemos que es una excelente oportunidad para compartir con la familia o amigos.<br />
                                <strong>No se podrá respetar la ubicación que tenías</strong>, sino que muy probablemente seas reubicado en otro Sector. Recuerda que las entradas para este show son bastante más caras que las de Vendimia, por lo que tendrás allí un beneficio.<br />
                                <strong>Para hacer este nuevo canje debes acudir a los mismos Centros habilitados para tal fin a partir de este Jueves 12 de Marzo a las 12hs. del mediodía</strong> (no vayas antes porque no estará habilitado) y llevar el PDF de la compra original de las entradas (no las entradas físicas que te dimos en el primer canje).<br /><br />
                                <strong>El canje será realizado hasta Agotar stock de lugares disponibles y está únicamente habilitada para las entradas compradas en el sitio de Entradaweb.</strong>
                            </p>

                            <p className="mb-2">Te recordamos cuáles son los Centros de Canje:</p>
                            <p className="mb-2"><strong>Puntos de Canje en Gran Mendoza (abiertos de 9 a 18hs.)</strong></p>
                            <ul className="mb-3">
                                <li>Teatro Independencia (Chile esq. Espejo. Ciudad)</li>
                                <li>Espacio Cultural Julio Le Parc (Mitre esq. Godoy Cruz, Guaymallén)</li>
                                <li>Auditorio Angel Bustelo (Virgen del Carmen de Cuyo 610. Ciudad)</li>
                                <li>Subsecretaría de Cultura (Gutiérrez 204. Ciudad)</li>
                            </ul>

                            <p className="mb-2"><strong>Puntos de Canje en San Martín, Tunuyán y San Rafael</strong></p>
                            <ul className="mb-3">
                                <li>Salón Cultural predio Las Bóvedas (Godoy Cruz y Pirovano, San Martín)</li>
                                <li>Auditorio Municipal de Tunuyán (Leandro N. Alem 750, Tunuyán)</li>
                                <li>Teatro Roma (Av. Hipólito Yrigoyen 280, San Rafael)</li>
                            </ul>

                            <p className="mb-3">
                                <strong>2..</strong> <strong>Puedes pedir la devolución del dinero de las entradas</strong> enviando un mail a <span className="email-link">devolucionvendimia@entradaweb.com.ar</span> haciendo el pedido y colocando el Código de Venta de tu compra, que es el número que está debajo del QR. Las devoluciones se realizarán entre mañana Jueves 12 y el Domingo 22 de Marzo contra el mismo medio de pago utilizado en tu compra. Te enviaremos comprobante vía email.
                                Si las entradas tienen registrado canje para el evento del día Domingo, por supuesto no habrá ningún tipo de devolución.
                            </p>

                            <p className="mb-3">
                                <strong>Muchas gracias por la comprensión.</strong> Como mendocinos duele en el alma tener que cancelar la Repetición del Acto Central, pero lamentablemente no se dan las condiciones.
                                Aprovecha el show del día Domingo, recuerda que es con stock limitado.
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default BotonArrepentimiento;
